import { useEffect, useState } from "react";
import { ActionButton, Breadcrumb } from "../../common/Buttons/Buttons";
import { Header } from "../../common/Header/Header.jsx";
import { SelectPerPage } from "../../common/Forms/Input/Input";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as schemas from "../../../assets/schemas/schemas";
import {
  Tables,
  InternalProviderTable,
  VehicularAssetsTable,
} from "../../common/Tables/Tables";
import {
  craneTableheader,
  internalProviderTableHeader,
  vehicularAssetsTableHeader,
} from "../../../assets/helpers/tables";
import {
  getProvidersEnum,
  providersOptions,
  isActiveOptions,
} from "../../../assets/helpers/options";
import { operationsRoles } from "../../../assets/helpers/roles";
import { providersService } from "../../../services/providersService";
import { vehicularAssetsService } from "../../../services/vehicularAssetsService";
import { statesService } from "../../../services/statesService";
import { notify } from "../../../assets/helpers/toast";
import { Select, SearchInput } from "../../common/Forms/Input/Input";
import { useHistory } from "react-router-dom";
import {
  exists,
  filterParams,
  capitalize,
} from "../../../assets/helpers/funciones";
import "./Providers.scss";
import { ActivateDriverModal } from "../../common/Modals/Modals.jsx";
import authService from "../../../services/authService.js";

const itemsPerpage = [10, 25, 50, 100, 500];

export const ExternalProviders = () => {
  const history = useHistory();
  const [statesOptions, setStatesOptions] = useState([]);
  const [providersDataTable, setProvidersDataTable] = useState({
    limit: itemsPerpage[0],
    offset: 0, //Elementos que ya pasaron la pagina
    data: [],
    count: 0, //Cantidad de elementos
    page: 1,
    type: getProvidersEnum.CRANE,
    isInternal: false,
    isLoading: true,
    state: "",
    isActive: "",
  });

  const links = [
    { name: "Home", url: "/services" },
    { name: "Proveedores", url: "/providers/external" },
  ];

  const handleProviderType = (e) => {
    const { value } = e.target;
    setProvidersDataTable((prevState) => {
      return {
        ...prevState,
        page: 1,
        offset: 0,
        type: value,
        description: "",
      };
    });
  };

  const selectitemsPerpage = (event) => {
    setProvidersDataTable((prevState) => {
      return {
        ...prevState,
        page: 1,
        offset: 0,
        limit: parseInt(event.target.value),
      };
    });
  };

  const handlePageChange = (event, value) => {
    setProvidersDataTable((prevState) => {
      return {
        ...prevState,
        page: value,
        offset: (value - 1) * providersDataTable?.limit,
      };
    });
  };

  const handleActiveFilter = (e) => {
    const { value } = e.target;
    setProvidersDataTable((prevState) => {
      return {
        ...prevState,
        page: 1,
        offset: 0,
        isActive: value,
      };
    });
  };

  const handleStateChange = (e) => {
    const { value } = e.target;
    setProvidersDataTable((prevState) => {
      return {
        ...prevState,
        page: 1,
        offset: 0,
        state: value,
      };
    });
  };

  const getProviders = (byMail) => {
    setProvidersDataTable((prevState) => {
      return {
        ...prevState,
        isLoading: true,
      };
    });
    let params = {
      type: providersDataTable?.type,
      offset: providersDataTable?.offset,
      limit: providersDataTable?.limit,
      isInternal: providersDataTable?.isInternal,
      description: providersDataTable?.description,
      isActive: providersDataTable?.isActive,
      state: providersDataTable?.state,
      byMail: byMail,
    };

    providersService
      .getProvidersByType(filterParams(params))
      .then((response) => {
        if (response.status === 200 && !byMail) {
          setProvidersDataTable((prevState) => {
            return {
              ...prevState,
              data: response?.data?.providers,
              count: response?.data?.count,
              isLoading: false,
            };
          });
          return null;
        }
        if (response.status === 200 && byMail) {
          notify(
            "Se ha enviado un correo con la información solicitada",
            "success"
          );
          setProvidersDataTable((prevState) => {
            return {
              ...prevState,
              isLoading: false,
            };
          });
        } else {
          notify(`${response.message}` || "error", "error");
          setProvidersDataTable((prevState) => {
            return {
              ...prevState,
              isLoading: false,
            };
          });
        }
      })
      .catch((error) => {
        setProvidersDataTable((prevState) => {
          return {
            ...prevState,
            isLoading: false,
          };
        });
      });
    return true;
  };

  const getStates = () => {
    statesService
      .getStates()
      .then((response) => {
        if (response.status === 200) {
          setStatesOptions([{ _id: "", name: "" }, ...response?.data?.states]);
        } else {
          notify(`${response.message}` || "error", "error");
        }
      })
      .catch((error) => { });
  };

  const handleSearchChange = (e) => {
    const { value } = e?.target;
    setProvidersDataTable((prevState) => {
      return {
        ...prevState,
        description: value,
        page: 1,
        offset: 0,
      };
    });
    if (!value) {
      window.location.reload();
    }
  };

  const handleEdit = (e) => {
    history.push(`/providers/external/edit/${e?._id}`);
  };

  useEffect(() => {
    getProviders();
    getStates();
  }, [
    providersDataTable?.page,
    providersDataTable?.offset,
    providersDataTable?.limit,
    providersDataTable?.type,
    providersDataTable?.isActive,
    providersDataTable?.state,
  ]);

  return (
    <>
      <Header />
      <div className="service-with-container container">
        <h1 className="title-component">
          Proveedores externos: {exists(providersDataTable?.count)}
        </h1>
        <div className="breadcrumb-container">
          <Breadcrumb links={links} />
          <div className="providers-buttons-container">
            <Select
              options={statesOptions}
              label={"Estado"}
              value={providersDataTable?.state}
              onChange={handleStateChange}
            />
            <Select
              options={isActiveOptions}
              label={"Status"}
              value={providersDataTable?.isActive}
              onChange={handleActiveFilter}
            />

            {[
              operationsRoles?.operationsAdmin,
              operationsRoles?.operationsDev,
              operationsRoles?.operationsSupervisor,
            ]?.includes(authService?.getUserType()) && (
                <>
                  <ActionButton
                    action={() => history.push("/providers/external/create")}
                    label={"+ Nuevo Proveedor"}
                  />
                  {![operationsRoles?.operationsSupervisor]?.includes(
                    authService?.getUserType()
                  ) && (
                      <ActionButton
                        action={() => getProviders(true)}
                        label={"Exportar"}
                      />
                    )}
                </>
              )}
          </div>
        </div>
        <div className="gray-line"></div>

        <div className="filter-button-container"></div>
        <br />
        <div className="breadcrumb-container">
          <span></span>
          <div className="service-filter-buttons-container">
            <SelectPerPage
              label={"Registros por página"}
              options={itemsPerpage}
              value={providersDataTable?.limit}
              onChange={selectitemsPerpage}
            />
            <SearchInput
              placeholder={"Nombre, Apellido o Documento de Identidad"}
              width="360px"
              value={providersDataTable?.description}
              onChange={handleSearchChange}
              searchAction={getProviders}
            />
          </div>
        </div>
        <Tables
          header={craneTableheader}
          dataTable={providersDataTable}
          handlePageChange={handlePageChange}
          edit={handleEdit}
        />
      </div>
    </>
  );
};

export const InternalProviders = () => {
  const history = useHistory();
  const links = [
    { name: "Home", url: "/services" },
    { name: "Chóferes", url: "/fleet/internal" },
  ];

  const [providersDataTable, setProvidersDataTable] = useState({
    limit: itemsPerpage[0],
    offset: 0, //Elementos que ya pasaron la pagina
    data: [],
    count: 0, //Cantidad de elementos
    page: 1,
    type: getProvidersEnum.ROAD_ATTENDANT,
    isInternal: true,
    isLoading: true,
    description: "",
  });

  const [driverModal, setDriverModal] = useState({
    selected: "",
    show: false,
  });

  const {
    register,
    watch,
    handleSubmit,
    formState: { errors },
    reset,
    setError,
    setValue,
  } = useForm({
    resolver: yupResolver(schemas.ActivateDriverSchema()),
  });

  const [vehicleList, setVehicleList] = useState([]);
  const [filteredVehicleList, setfilteredVehicleList] = useState([]);
  const [isLoading, setIsloading] = useState(false);

  const onSubmit = handleSubmit(async (data) => {
    if (driverModal?.selected?.isActive === "Inactivo" && !data?.vehicle) {
      setError("vehicle", {
        type: "custom",
        message: "Obligatorio",
      });
      return null;
    }

    let dataToPost = {
      vehicle: data?.vehicle,
      isActive: driverModal?.selected?.isActive === "Activo" ? false : true,
    };

    if (!isLoading) {
      setIsloading(true);
      providersService
        .acrtivateProvider(filterParams(dataToPost), driverModal?.selected?._id)
        .then((response) => {
          if (response.status === 200) {
            notify(`Chofer editado con éxito`, "success");
            setIsloading(false);
            activateProvider();
            reset();
            getProviders();
            getAvailableVehicles();
          } else {
            notify(`${response.message}`, "error");
            setIsloading(false);
          }
        })
        .catch((error) => {
          setIsloading(false);
        });
    }
  });

  const handleProviderType = (e) => {
    const { value } = e.target;
    setProvidersDataTable((prevState) => {
      return {
        ...prevState,
        page: 1,
        offset: 0,
        type: value,
        description: "",
      };
    });
  };

  const selectitemsPerpage = (event) => {
    setProvidersDataTable((prevState) => {
      return {
        ...prevState,
        page: 1,
        offset: 0,
        limit: parseInt(event.target.value),
      };
    });
  };

  const handlePageChange = (event, value) => {
    setProvidersDataTable((prevState) => {
      return {
        ...prevState,
        page: value,
        offset: (value - 1) * providersDataTable?.limit,
      };
    });
  };

  const getProviders = (byMail) => {
    setProvidersDataTable((prevState) => {
      return {
        ...prevState,
        isLoading: true,
      };
    });

    let params = {
      type: providersDataTable?.type,
      offset: providersDataTable?.offset,
      limit: providersDataTable?.limit,
      isInternal: providersDataTable?.isInternal,
      description: providersDataTable?.description,
      byMail: byMail,
    };

    providersService
      .getProvidersByType(filterParams(params))
      .then((response) => {
        if (response.status === 200) {
          setProvidersDataTable((prevState) => {
            return {
              ...prevState,
              data: response?.data?.providers,
              count: response?.data?.count,
              isLoading: false,
            };
          });
        } else {
          notify(`${response.message}` || "error", "error");
          setProvidersDataTable((prevState) => {
            return {
              ...prevState,
              isLoading: false,
            };
          });
        }
      })
      .catch((error) => {
        setProvidersDataTable((prevState) => {
          return {
            ...prevState,
            isLoading: false,
          };
        });
      });
    return true;
  };

  const handleSearchChange = (e) => {
    const { value } = e?.target;
    setProvidersDataTable((prevState) => {
      return {
        ...prevState,
        description: value,
        page: 1,
        offset: 0,
      };
    });
    if (!value) {
      window.location.reload();
    }
  };

  const handleEdit = (e) => {
    history.push(`/fleet/internal/edit/${e?._id}`);
  };

  const activateProvider = (data, active) => {
    setDriverModal((prevState) => {
      return {
        show: !driverModal.show,
        options: vehicleList,
        filteredOptions: filteredVehicleList,
        selected: data ? data : "",
      };
    });

    if (data) {
      setValue("vehicle", data?.vehicle?._id);
    } else {
      setValue("vehicle", "");
    }
  };

  const getAvailableVehicles = () => {
    vehicularAssetsService
      .getAvailableVehicles()
      .then((response) => {
        let data = [];

        data = response?.data?.map((a) => ({
          name: capitalize(a?.alias) + " " + (a?.plate).toUpperCase(),
          _id: a?._id,
          class: a?.class,
          provider: a?.provider,
        }));

        if (response.status === 200) {
          if (providersDataTable?.type === getProvidersEnum.ROAD_ATTENDANT) {
            data = data?.filter((a) => {
              return a.class === "MOTO";
            });
          }
          if (providersDataTable?.type === getProvidersEnum.CRANE) {
            data = data?.filter((a) => {
              return a.class === "GRÚA";
            });
          }

          setVehicleList(data);
          let filteredData = (data = data?.filter((a) => {
            return !a.provider;
          }));
          setfilteredVehicleList(filteredData);
        } else {
          notify(`${response.message}` || "error", "error");
        }
      })
      .catch((error) => { });
    return true;
  };

  useEffect(() => {
    getProviders();
    getAvailableVehicles();
  }, [
    providersDataTable?.page,
    providersDataTable?.offset,
    providersDataTable?.limit,
    providersDataTable?.type,
  ]);

  return (
    <>
      <ActivateDriverModal
        watch={watch}
        modal={driverModal}
        handleModal={activateProvider}
        action={onSubmit}
        register={register}
        errors={errors}
      />
      <Header />
      <div className="service-with-container container">
        <h1 className="title-component">
          Chóferes registrados: {exists(providersDataTable?.count)}
        </h1>
        <div className="breadcrumb-container">
          <Breadcrumb links={links} />
          <div className="providers-buttons-container">
            <Select
              options={providersOptions}
              label={"Servicio"}
              value={providersDataTable?.type}
              onChange={handleProviderType}
            />
            {[
              operationsRoles?.operationsAdmin,
              operationsRoles?.operationsDev,
              operationsRoles?.operationsSupervisor,
            ]?.includes(authService?.getUserType()) && (
                <>
                  <ActionButton
                    action={() => history.push("/fleet/internal/create")}
                    label={"+ Nuevo Chofer"}
                  />
                </>
              )}
          </div>
        </div>
        <div className="gray-line"></div>

        <div className="filter-button-container"></div>
        <br />
        <div className="breadcrumb-container">
          <span></span>
          <div className="service-filter-buttons-container">
            <SelectPerPage
              label={"Registros por página"}
              options={itemsPerpage}
              value={providersDataTable?.limit}
              onChange={selectitemsPerpage}
            />
            <SearchInput
              placeholder={"Nombre, Apellido o Documento de Identidad"}
              width="360px"
              value={providersDataTable?.description}
              onChange={handleSearchChange}
              searchAction={getProviders}
            />
          </div>
        </div>
        <InternalProviderTable
          header={internalProviderTableHeader}
          dataTable={providersDataTable}
          handlePageChange={handlePageChange}
          edit={handleEdit}
          activateProvider={activateProvider}
        />
      </div>
    </>
  );
};

export const Fleet = () => {
  const history = useHistory();
  const links = [
    { name: "Home", url: "/services" },
    { name: "Flota ", url: "/fleet" },
  ];

  const [vehicularAssets, setVehicularAssets] = useState({
    limit: itemsPerpage[1],
    offset: 0, //Elementos que ya pasaron la pagina
    data: [],
    count: 0, //Cantidad de elementos
    page: 1,
    isLoading: true,
    description: "",
  });

  const selectitemsPerpage = (event) => {
    setVehicularAssets((prevState) => {
      return {
        ...prevState,
        page: 1,
        offset: 0,
        limit: parseInt(event.target.value),
      };
    });
  };

  const handlePageChange = (event, value) => {
    setVehicularAssets((prevState) => {
      return {
        ...prevState,
        page: value,
        offset: (value - 1) * vehicularAssets?.limit,
      };
    });
  };

  const getProviders = () => {
    setVehicularAssets((prevState) => {
      return {
        ...prevState,
        isLoading: true,
      };
    });

    vehicularAssetsService
      .getVehicularAssets(vehicularAssets)
      .then((response) => {
        if (response.status === 200) {
          setVehicularAssets((prevState) => {
            return {
              ...prevState,
              data: response?.data?.vehicularAssets,
              count: response?.data?.count,
              isLoading: false,
            };
          });
        } else {
          notify(`${response.message}` || "error", "error");
          setVehicularAssets((prevState) => {
            return {
              ...prevState,
              isLoading: false,
            };
          });
        }
      })
      .catch((error) => {
        setVehicularAssets((prevState) => {
          return {
            ...prevState,
            isLoading: false,
          };
        });
      });
    return true;
  };

  const handleEdit = (e) => {
    history.push(`/fleet/edit/${e?._id}`);
  };

  useEffect(() => {
    getProviders();
  }, [vehicularAssets?.page, vehicularAssets?.offset, vehicularAssets?.limit]);

  return (
    <>
      <Header />
      <div className="service-with-container container">
        <h1 className="title-component">
          Flota / Vehiculos Registrados: {exists(vehicularAssets?.count)}
        </h1>
        <div className="breadcrumb-container">
          <Breadcrumb links={links} />
          <div className="providers-buttons-container">
            <span></span>
            {[
              operationsRoles?.operationsAdmin,
              operationsRoles?.operationsDev,
            ]?.includes(authService?.getUserType()) && (
                <>
                  <ActionButton
                    action={() => history.push("/fleet/create")}
                    label={"+ Nuevo Vehículo"}
                  />
                </>
              )}
          </div>
        </div>
        <div className="gray-line"></div>

        <div className="filter-button-container"></div>
        <br />
        <div className="breadcrumb-container">
          <span></span>
          <div className="service-filter-buttons-container">
            <SelectPerPage
              label={"Registros por página"}
              options={itemsPerpage}
              value={vehicularAssets?.limit}
              onChange={selectitemsPerpage}
            />
            {/* <SearchInput
              placeholder={'Nombre, Apellido o Documento de Identidad'}
              width="360px"
              value={vehicularAssets?.description}
              onChange={handleSearchChange}
              searchAction={getProviders}
            /> */}
          </div>
        </div>
        <VehicularAssetsTable
          header={vehicularAssetsTableHeader}
          dataTable={vehicularAssets}
          handlePageChange={handlePageChange}
          edit={handleEdit}
        />
      </div>
    </>
  );
};
